import * as React from 'react';

import type { DataWarehouse } from 'data-warehouse/Types';

type Props = {
  archive: DataWarehouse
}

const RestoredArchivesCell = ({ archive }: Props) => (
  <span>{archive.restore_history == null ? 0 : archive.restore_history.length}</span>
);

export default RestoredArchivesCell;
